<template>
  <div>
    <!-- Gerenciamento dos Motivos de Dispensa -->
    <v-dialog
      v-model="visibilidade"
      max-width="800"
      persistent
    >
      <v-card>
        <v-card-text>
          <!-- Formulário de casdatro e edição -->
          <v-card flat>
            <v-form
              ref="form"
              @submit.prevent="onSubmit"
            >
              <v-card-text>
                <v-row>
                  <h4 class="headline primary--text text-no-wrap">
                    {{ isEdicao ? "Editar" : "Adicionar" }} Motivo de Dispensa
                  </h4>
                </v-row>
                <v-row>
                  Digite a descrição do motivo de dispensa a ser {{ isEdicao ? "editado" : "adicionado" }}
                </v-row>
                <v-row>
                  <v-text-field
                    v-model.trim="motivo.descricao"
                    autofocus
                    label="Descrição"
                  />
                </v-row>
              </v-card-text>

              <!-- Botões -->
              <v-card-actions>
                <v-spacer />
                <v-btn
                  :disabled="motivo.descricao.trim() === ''"
                  color="primary"
                  type="submit"
                >
                  {{ isEdicao ? "Editar" : "Adicionar" }}
                </v-btn>
                <v-btn
                  color="primary"
                  outlined
                  @click="toogle"
                >
                  Cancelar
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>

          <!-- Motivos de Dispensa -->
          <v-card v-if="motivos.length > 0" flat>
            <v-card-text class="py-0">
              <!-- Título -->
              <v-row>
                <h4 class="headline primary--text text-no-wrap">Motivos de Dispensa</h4>
              </v-row>

              <!-- Tabela -->
              <v-data-table
                :items="motivos"
                :headers="headers"
                :search="opcoes.pesquisa"
                :sort-by="opcoes.ordenarPor"
                :sort-desc="opcoes.decrescente"
                :items-per-page="5"
                item-key="id"
              >
                <!-- Pesquisa e Ordenação -->
                <template v-slot:top>
                  <v-row dense>
                    <v-col cols="12" md="4">
                      <app-sort v-model="opcoes" />
                    </v-col>
                    <v-col cols="0" md="4" />
                    <v-col cols="12" md="4">
                      <app-search v-model="opcoes" />
                    </v-col>
                  </v-row>
                </template>

                <!-- Botões de Ação -->
                <template v-slot:[`item.acoes`]="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-if="item.usuarioResponsavel"
                        icon
                        small
                        color="secondary"
                        class="mr-2"
                        v-on="on"
                        @click="editar(item)"
                      >
                        <v-icon>edit</v-icon>
                      </v-btn>
                    </template>
                    <span>Clique no botão para editar a dispensa</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-if="item.usuarioResponsavel"
                        icon
                        small
                        color="error"
                        v-on="on"
                        @click="confirmarExclusao(item)"
                      >
                        <v-icon>delete</v-icon>
                      </v-btn>
                    </template>
                    <span>Clique no botão para excluir a dispensa</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Janela de Dialogo para confirmação da exclusão -->
    <dialog-remove
      v-show="dialogRemove.visibilidade"
      :confirm-action="excluir"
      :dialog-visible="dialogRemove.visibilidade"
      :toogle-visible="toogleDialogRemove"
      descricao="Você realmente deseja excluir esse motivo?"
    />
  </div>
</template>

<script>
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import AppSort from '@/components/core/AppSort';
import AppSearch from '@/components/core/AppSearch';
import DialogRemove from '@/components/DialogRemove';

const motivoDispensaDiagnosticoRepository = RepositoryFactory.get('motivoDispensaDiagnostico');

export default {
  name: 'GerenciamentoMotivoDispensa',

  components: {
    AppSort,
    AppSearch,
    DialogRemove,
  },

  props: {
    motivos: {
      type: Array,
      required: false,
      default: () => ([]),
    },
    dispensas: {
      type: Array,
      required: false,
      default: () => ([]),
    },
    visibilidade: {
      type: Boolean,
      required: true,
      default: false,
    },
    toogle: {
      type: Function,
      default: () => {},
    },
    isEdicao: {
      type: Boolean,
      required: false,
      default: false,
    },
    motivoUpdate: {
      type: Object,
      default: null,
      required: false,
    },
  },

  data() {
    return {
      motivo: {
        id: null,
        descricao: '',
      },
      headers: [
        {
          text: 'DESCRIÇÃO',
          value: 'descricao',
          sortable: false,
        },
        {
          text: '',
          value: 'acoes',
          sortable: false,
          width: '20%',
          align: 'end',
        },
      ],
      opcoes: {
        pesquisa: '',
        decrescente: false,
        ordenarPor: 'descricao',
        selecionado: { id: 'descricao', descricao: 'Descrição' },
        lista: [
          { id: 'descricao', descricao: 'Descrição' },
        ],
      },
      dialogRemove: { visibilidade: false, item: null },
    };
  },

  watch: {
    motivoUpdate(value) {
      if (value && this.isEdicao) {
        this.motivo = { ...value };
      } else {
        this.motivo = { id: null, descricao: '' };
      }
    },
  },

  methods: {
    onSubmit() {
      if (this.motivo.descricao.trim() !== '') {
        const save = this.isEdicao ? 'update' : 'create';
        const message = this.isEdicao ? 'Motivo editado com sucesso!' : 'Motivo adicionado com sucesso!';

        motivoDispensaDiagnosticoRepository[save](this.motivo).then((response) => {
          const motivo = response.data;
          this.$emit('return', motivo);
          this.motivo = { id: null, descricao: '' };

          if (this.isEdicao) {
            this.$emit('reset');
          }
          this.$store.dispatch('app/success', { response, message });
        });
      }
    },
    editar(item) {
      this.$emit('update', item);
    },
    confirmarExclusao(item) {
      this.dialogRemove.item = { ...item };
      this.toogleDialogRemove();
    },
    toogleDialogRemove() {
      this.dialogRemove.visibilidade = !this.dialogRemove.visibilidade;
      if (!this.dialogRemove.visibilidade) {
        this.dialogRemove.item = null;
      }
    },
    excluir() {
      if (this.dialogRemove.item) {
        motivoDispensaDiagnosticoRepository.delete(this.dialogRemove.item.id).then((response) => {
          this.$emit('delete', this.dialogRemove.item);
          this.toogleDialogRemove();
          this.$store.dispatch('app/success', {
            response,
            message: 'Motivo excluído com sucesso!',
          });
        });
      }
    },
  },
};
</script>
